import { render } from "./TotalsBySecurityType.vue?vue&type=template&id=f242ba86"
import script from "./TotalsBySecurityType.vue?vue&type=script&lang=js"
export * from "./TotalsBySecurityType.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__